/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { SelectWithSearch, UploadInputV2 } from "@/components/form-input";
import { Button } from "@/components/ui/button";
import { IconRender } from "@/components/shared/Icon-render";
import { useEffect } from "react";
import { RequiredInput } from "@/components/shared/required-input";
import { useReactForm } from "./use-react-form";
import { SelectRetailer } from "@/components/form-input/select-retailer";

export const SingleDocumentUpload = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  workflowList,
  currentCompanyData,
  allRetailerList,
}: {
  formData: any;
  onOpenChange: any;
  onFormSubmit: any;
  open: any;
  workflowList: any;
  currentCompanyData: any;
  allRetailerList: any;
}) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  useEffect(() => {
    form.setValue(
      "workflow_id",
      currentCompanyData?.settings?.default_workflow,
    );
  }, [currentCompanyData?.settings?.default_workflow]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="file_path"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Upload
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <UploadInputV2
                    placeholder="File Path"
                    value={field.value}
                    onChange={field.onChange}
                  />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <div className="grid md:grid-cols-2 gap-x-6">
            <FormField
              control={form.control}
              name="workflow_id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    Workflow
                    <RequiredInput />
                  </FormLabel>
                  <FormControl>
                    <SelectWithSearch
                      bindLabel="name"
                      bindValue="workflow_id"
                      placeholder="Select Workflow"
                      options={workflowList}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="retailer_id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Retailer</FormLabel>
                  <FormControl>
                    <SelectRetailer
                      bindLabel="retailer_name"
                      bindValue="retailer_id"
                      placeholder="Select Retailer"
                      options={allRetailerList}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>

        <div className="mt-10 px-6 py-4 flex gap-5 w-full border border-r-0 border-l-0 border-b-0">
          <Button
            type="submit"
            className="w-[120px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Submit"
            )}
          </Button>
          <Button
            type="submit"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </div>
      </form>
    </Form>
  );
};
